// extracted by mini-css-extract-plugin
module.exports = {"root":"Burger_root__2xb6I","active":"Burger_active__3bCKF","item":"Burger_item__ZGKMp"};